export const REVIEWS_PER_PAGE = 10;

export interface ProductSummaryBreakdown {
  [key: string]: number;
}

export interface ProductReviewsSummary {
  rating: number;
  count: number;
  breakdown: ProductSummaryBreakdown;
}

export interface ProductReview {
  author: string;
  title: string;
  message: string;
  rating: number;
  date: Date;
}

export interface ProductReviews {
  items: ProductReview[];
  page: number;
  total: number;
}

export interface RawProductReviews {
  data: {
    author: string;
    title: string;
    message: string;
    rating: string;
    date: string;
  }[];
  page: number;
  total: number;
}

export interface RawProductReviewsSummary {
  rating: number;
  count: number;
  breakdown: ProductSummaryBreakdown;
}

export const EMPTY_REVIEWS_SUMMARY: ProductReviewsSummary = {
  rating: 0,
  count: 0,
  breakdown: {
    '1': 0,
    '2': 0,
    '3': 0,
    '4': 0,
    '5': 0,
  },
};
